import {IOrders} from "../../../../models/types";

export const isCompareVersionProject = (orderServer: IOrders, projectOrder: IOrders) => {
    return JSON.stringify(orderServer.orderAttributes) === JSON.stringify(projectOrder.orderAttributes);
}